<template>
  <!-- ---------------------------------- 搜索页面 ---------------------------------- -->
  <div class="search">
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Header></Header>
    <!-- ---------------------------------- 间隔 ---------------------------------- -->
    <div class="interval"></div>
    <!-- ---------------------------------- 搜索栏 ---------------------------------- -->
    <div class="search_tab">
      <div class="search_main">
        <input type="text" v-model="searchData" placeholder="搜索" />
        <!-- 图标-放大镜 -->
        <img
          style="cursor: pointer"
          @click="search"
          src="../assets/images/icon/search-blue.png"
          alt=""
        />
      </div>
    </div>
    <!-- ---------------------------------- 搜索结果 ---------------------------------- -->
    <div class="results">
      <p class="results_title">
        为您找到相关结果约{{
          tabId == 0
            ? cpDataList.length
            : tabId == 1
            ? fwDataList.length
            : tabId == 2
            ? zxDataList.length
            : 0
        }}个
      </p>
      <!-- 切换标签 -->
      <div class="results_tab">
        <span
          class="results_span"
          :class="tabId === index ? 'select_tab' : ''"
          v-for="(item, index) of tabList"
          :key="index"
          @click="tabId = index"
        >
          {{ item }}
        </span>
      </div>
      <!-- 切换页一 -->
      <div class="tabs_one" v-if="tabId === 0">
        <!-- 结果 -->
        <div class="product_results">
          <!-- 产品内容 -->
          <div
            class="results_main"
            v-for="(item1, index) in cpDataList"
            @click="tiaoZhuan1(item1.title)"
          >
            <div style="height: 100%">
              <img
                v-if="item1.title === 'RA488高效空气净化器'"
                v-lazy="
                  'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                  item1.picUrl
                "
                alt=""
              />
              <img
                v-if="item1.title === 'RA800高效空气净化器'"
                v-lazy="
                  'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                  item1.picUrl
                "
                alt=""
              />
              <img
                v-if="item1.title === 'PN-02B/W等离子纳米空气净化器'"
                v-lazy="
                  'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                  item1.picUrl
                "
                alt=""
              />
              <img
                v-if="item1.title === 'RA488 H13高效HEPA复合滤网'"
                v-lazy="item1.picUrl"
                alt=""
              />
              <img
                v-if="item1.title === 'RA488加湿滤网'"
                v-lazy="item1.picUrl"
                alt=""
              />
              <img
                v-if="item1.title === 'RA800复合滤网'"
                v-lazy="item1.picUrl"
                alt=""
              />
              <img
                v-if="item1.title === 'H13 高效HEPA复合滤网 (PN-02B/W)'"
                v-lazy="item1.picUrl"
                alt=""
              />
              <p>
                <a class="title2">{{ item1.title }}</a>
              </p>
            </div>
          </div>
        </div>
        <!-- 更多按钮 -->
        <img
          class="results_more"
          v-if="false"
          src="../assets/images/icon/results-more.png"
          alt=""
        />
      </div>
      <!-- 切换页一 -->
      <div class="tabs_one" v-if="tabId === 1">
        <!-- 结果 -->
        <div class="product_results">
          <!-- 产品内容 -->
          <div class="results_main" v-for="(item2, index) in fwDataList">
            <div style="height: 100%">
              <img
                v-lazy="
                  'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                  item2.picUrl
                "
                alt=""
              />
              <p>
                <a  class="title2" @click="tiaoZhuan2(item2.title)">{{
                  item2.title
                }}</a>
              </p>
            </div>
          </div>
        </div>
        <!-- 更多按钮 -->
        <img
          class="results_more"
          v-if="false"
          src="../assets/images/icon/results-more.png"
          alt=""
        />
      </div>
      <!-- 切换页一 -->
      <div class="tabs_one" v-if="tabId === 2">
        <!-- 结果 -->
        <div class="product_results">
          <!-- 产品内容 -->
          <div class="results_main" v-for="(item3, index) in zxDataList">
            <div style="height: 100%">
              <img
                v-lazy="
                  'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                  item3.picUrl
                "
                alt=""
              />
              <p>
                <a
                  class="title2"
                  v-if="item3.backup1 == 1"
                  @click="tiaoZhuan3(item3.id)"
                  >{{ item3.title }}</a
                >
                <a
                 class="title2"
                  v-if="item3.backup1 == 2"
                  @click="toBlogDetails(item3.id)"
                  >{{ item3.title }}</a
                >
              </p>
            </div>
          </div>
        </div>
        <!-- 更多按钮 -->
        <img
          class="results_more"
          v-if="false"
          src="../assets/images/icon/results-more.png"
          alt=""
        />
      </div>
    </div>
    <!-- ---------------------------------- 底部栏 ---------------------------------- -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Axios from "axios";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      relevantResults: 0, // 相关结果
      searchData: "",
      tabList: ["产品 (7)", "服务 (2)"],
      tabId: 0,
      number: 0,
      cpDataList: [
        {
          title: "RA488高效空气净化器",
          picUrl: "temp/488-1_1622715507397.png",
        },
        {
          title: "RA800高效空气净化器",
          picUrl: "temp/RA800-front3d_1622777097031.png",
        },
        {
          title: "PN-02B/W等离子纳米空气净化器",
          picUrl: "temp/PN-02B_1622776815590.png",
        },
        {
          title: "RA488 H13高效HEPA复合滤网",
          picUrl: "/static/img/ra488-pic2.6ec1952.png",
        },
        {
          title: "RA488加湿滤网",
          picUrl: "/static/img/ra488-pic.8a366e6.png",
        },
        {
          title: "RA800复合滤网",
          picUrl: "/static/img/air-glpj.be8c47e.png",
        },
        {
          title: "H13 高效HEPA复合滤网 (PN-02B/W)",
          picUrl: "/static/img/pn-pic1.115d198.png",
        },
      ],
      fwDataList: [
        {
          title: "净化器清洁服务",
          picUrl: "temp/care-banner1_1623921237467.png",
        },
        {
          title: "合约期外保养服务",
          picUrl: "temp/care-banner2_1623921245614.png",
        },
      ],
      zxDataList: [],
    };
  },
  created() {
    this.tiaoZhuan();
  },
  methods: {
    tiaoZhuan() {
      var that = this;
      let setId = this.$route.query.setId;
      if (setId === undefined) {
        return;
      } else {
        that.searchData = setId;
        this.search();
      }
    },

    toBlogDetails(item) {
      this.$router.push({
        path: "/blogDetails",
        query: {
          id: item,
        },
      });
    },
    tiaoZhuan1(val) {
      let tableId = 0;
      if (
        val === "RA488高效空气净化器" ||
        val === "RA488 H13高效HEPA复合滤网" ||
        val === "RA488加湿滤网"
      ) {
        tableId = 0;
      }
      if (val === "RA800高效空气净化器" || val === "RA800复合滤网") {
        tableId = 1;
      }
      if (
        val === "PN-02B/W等离子纳米空气净化器" ||
        val === "H13 高效HEPA复合滤网 (PN-02B/W)"
      ) {
        tableId = 2;
      }
      this.$router.push({ name: "air", params: { tabId: tableId } });
    },
    tiaoZhuan2(val) {
      let tableId = 0;
      if (val === "净化器清洁服务") {
        tableId = 0;
      }
      if (val === "合约期外保养服务") {
        tableId = 1;
      }
      this.$router.push({ path: "/care", query: { setId: tableId } });
    },
    tiaoZhuan3(val) {
      this.$router.push({
        path: "/information_main",
        query: { setId: val },
      });
    },
    search() {
      var that = this;
      that.getConsult();
      that.tabList = [];
      let cpList = [];
      let fwList = [];
      that.cpDataList = [
        {
          title: "RA488高效空气净化器",
          picUrl: "temp/488-1_1622715507397.png",
        },
        {
          title: "RA800高效空气净化器",
          picUrl: "temp/RA800-front3d_1622777097031.png",
        },
        // {
        //   title: "PN-02B/W等离子纳米空气净化器",
        //   picUrl: "temp/PN-02B_1622776815590.png",
        // },
        {
          title: "RA488 H13高效HEPA复合滤网",
          picUrl: "/static/img/ra488-pic2.6ec1952.png",
        },
        {
          title: "RA488加湿滤网",
          picUrl: "/static/img/ra488-pic.8a366e6.png",
        },
        {
          title: "RA800复合滤网",
          picUrl: "/static/img/air-glpj.be8c47e.png",
        },
        // {
        //   title: "H13 高效HEPA复合滤网 (PN-02B/W)",
        //   picUrl: "/static/img/pn-pic1.115d198.png",
        // },
      ];
      that.fwDataList = [
        {
          title: "净化器清洁服务",
          picUrl: "temp/care-banner1_1623921237467.png",
        },
        {
          title: "合约期外保养服务",
          picUrl: "temp/care-banner2_1623921245614.png",
        },
      ];
      let s = that.searchData.toLowerCase();
      if (s) {
        that.cpDataList.filter((item) => {
          if (item.title.toLowerCase().indexOf(s) !== -1) {
            cpList.push({
              title: item.title,
              picUrl: item.picUrl,
            });
          }
        });
        that.cpDataList = cpList;
        that.tabList.push("产品(" + that.cpDataList.length + ")");
      } else {
        that.tabList.push("产品(" + that.cpDataList.length + ")");
      }
      if (s) {
        that.fwDataList.filter((item) => {
          if (item.title.toLowerCase().indexOf(s) !== -1) {
            fwList.push({
              title: item.title,
              picUrl: item.picUrl,
            });
          }
        });
        that.fwDataList = fwList;
        that.tabList.push("服务(" + that.fwDataList.length + ")");
      } else {
        that.tabList.push("服务(" + that.fwDataList.length + ")");
      }
    },
    //获取咨询信息
    getConsult() {
      var that = this;
      that.zxDataList = [];
      let url =
        "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getConsult?title=" +
        that.searchData;
      Axios.get(url).then((res) => {
        if (res.data.success === true) {
          for (let i = 0; i < res.data.result.records.length; i++) {
            that.zxDataList.push({
              id: res.data.result.records[i].id,
              title: res.data.result.records[i].title,
              picUrl: res.data.result.records[i].cover,
              backup1: res.data.result.records[i].backup1,
            });
          }
          if (that.tabList.length < 3) {
            that.tabList.push("资讯(" + that.zxDataList.length + ")");
          }
        }
        that.number = that.cpDataList.length + that.fwDataList.length;
        that.number += that.zxDataList.length;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* ------------------------------ 间隔 ----------------------------- */
.interval {
  width: 100%;
  height: 23px;
  background-color: #dddbdd;
}
/* ------------------------------ 搜索栏 ----------------------------- */
.search_tab {
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding: 55px 0 55px 161px;
  box-sizing: border-box;
  // 主体
  .search_main {
    width: 644px;
    height: 61px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 2px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 17px 0 23px;
    margin-left: 2%;
    // 图标
    img {
      width: 45px;
      height: 45px;
    }
    input {
      flex-grow: 1;
      border: none;
      line-height: 50px;
      font-size: 26px;
      color: #333333;
      outline: none;
    }
  }
}
/* ------------------------------ 搜索结果 ----------------------------- */
.results {
  width: 70%;
  margin: 0 auto;
  padding: 36px 0 0 0;
  margin: 0 16.6%;
  // 提示语
  .results_title {
    font-size: 18px;
    color: #3d3d3d;
    margin: 0 0 27px 0;
    letter-spacing: 2px;
  }
  // 切换标签
  .results_tab {
    text-align: center;
    display: flex;
    align-items: center;
    margin-top: 30px;
    // 默认状态标签
    .results_span {
      width: 155px;
      font-size: 20px;
      color: rgb(170, 170, 170);
      text-align: center;
      line-height: 45px;
      border: 1px solid rgb(170, 170, 170);
      border-radius: 50px;
      margin-right: 35px;
      display: block;
      cursor: pointer;
    }
    // 选中状态标签
    .select_tab {
      background-color: #43baec;
      color: #ffffff;
    }
  }
  // 切换页面
  .tabs_one {
    width: 100%;
    padding: 20px 0 0 0;
    // 结果
    .product_results {
      display: flex;
      align-items: center;
      margin-bottom: 120px;
      flex-wrap: wrap;
      // 产品内容
      .results_main {
        width: 270px;
        border: 1px solid rgb(170, 170, 170);
        box-sizing: border-box;
        border-radius: 10px;
        margin-right: 52px;
        height: 380px;
        overflow: hidden;
        text-align: center;
        cursor: pointer;
        margin-bottom: 3%;
        div {
          position: relative;
        }
        img {
          margin-bottom: 27%;
          height: 200px;
          position: absolute;
          top: 17%;
          margin: auto;
          left: 0;
          right: 0;
        }
        p {
          width: 100%;
          font-size: 18px;
          color: #43baec;
          text-align: center;
          letter-spacing: 2px;
          margin: 0;
          padding: 0 30px;
          position: absolute;
          bottom: 20%;
          left: 0;
          right: 0;
          height: 0%;
          a {
            text-overflow: ellipsis;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    .results_more {
      display: block;
      margin: 0 auto;
      margin-bottom: 1000px;
      width: 104px;
    }
  }

  // ------------- pc端样式 -------------
   @media only screen and (min-width: 960px) {
    .title2 {
      font-size: 16px;
    }
  }
//   @media only screen and (max-width: 960px) {
//     .title2 {
//       font-size: 15px;
//       color: #db6d6d;

//     }
//   }
}
</style>



// WEBPACK FOOTER //
// src/view/search.vue